import { useTranslation } from 'react-i18next';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useCreateEditAssetQuery = () => {
  const { showSuccess } = useNotifications();
  const { t } = useTranslation();

  const { mutate: createAsset, isLoading: isCreating } =
    trpc.createAsset.useMutation({
      onSuccess: () =>
        showSuccess(
          t(`common.notification.success.message`, {
            action: 'created',
            entity: 'asset',
          })
        ),
    });

  const { mutate: updateAsset, isLoading: isUpdating } =
    trpc.updateAsset.useMutation({
      onSuccess: () =>
        showSuccess(
          t(`common.notification.success.message`, {
            action: 'updated',
            entity: 'asset',
          })
        ),
    });

  const { mutate: assignAsset, isLoading: isAssignAssetLoading } =
    trpc.locations.linkAssetToLocation.useMutation({
      onSuccess: () =>
        showSuccess(
          t(`common.notification.success.message`, {
            action: 'assigned',
            entity: 'asset',
          })
        ),
    });

  const { mutate: deleteAsset, isLoading: isDeleting } =
    trpc.deleteAsset.useMutation({
      onSuccess: () =>
        showSuccess(
          t(`common.notification.success.message`, {
            action: 'deleted',
            entity: 'asset',
          })
        ),
    });
  const { mutate: deleteAssetLink, isLoading: isDeletingAssetLink } =
    trpc.locations.deleteLocationLinkedAsset.useMutation({
      onSuccess: () =>
        showSuccess(
          t(`common.notification.success.message`, {
            action: 'assigned',
            entity: 'asset',
          })
        ),
    });

  return {
    createAsset,
    updateAsset,
    deleteAsset,
    deleteAssetLink,
    assignAsset,
    isLoading:
      isCreating ||
      isUpdating ||
      isAssignAssetLoading ||
      isDeleting ||
      isDeletingAssetLink,
  };
};
